import { useInvalidateWorkflowQuery } from "./use-workflow-query";
import { useInvalidateWorkflowListQuery } from "./use-workflows-query";
import { useApiMutation } from "./use-api-mutation";

type UseUpdateWorkflowActivationParams = {
	shopId: string;
	workflowId: string;
};

export function useUpdateWorkflowActivation({
	shopId,
	workflowId,
}: UseUpdateWorkflowActivationParams) {
	const invalidateWorkflowListQuery = useInvalidateWorkflowListQuery(shopId);
	const invalidateWorkflowQuery = useInvalidateWorkflowQuery({
		shopId,
		workflowId,
	});
	return useApiMutation(
		"patch",
		"/shops/{shopId}/workflows/{workflowId}",
		{
			notify: false,
			invalidate: [invalidateWorkflowQuery, invalidateWorkflowListQuery],
			mapVariables: ({
				body,
				workflowId: wId,
			}: {
				body: { isActive: boolean };
				workflowId: string;
			}) => ({
				params: { path: { shopId, workflowId: wId } },
				body: {
					status: body.isActive ? "ACTIVE" : "INACTIVE",
				},
			}),
		},
	);
}
